var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('error-header-section',{attrs:{"title":_vm.title}}),_c('error-body-section',{attrs:{"message":_vm.message,"descriptions":_vm.descriptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }